import { useTypedParams } from '@sorare/routing';

import { CollectionLayout } from 'components/collections/CollectionLayout';

import type { LayoutParams } from './__generated__/routeParams';

const MyClubSlugCollectionLayout = () => {
  const { slug, collection } = useTypedParams<LayoutParams>();
  return (
    <CollectionLayout collection={collection} userSlug={slug} fromMyClub />
  );
};

export default MyClubSlugCollectionLayout;
